import { createFileRoute } from '@tanstack/react-router';
import { ShipmentsListPage } from '@/features/shipments/list-page';
import { listSearchSchema } from '@/features/shipments/search';

// S01 · the queue (07 §3): filters live in the URL.
export const Route = createFileRoute('/_app/shipments/')({
  validateSearch: listSearchSchema,
  component: ShipmentsListPage,
});
